import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/img/touxiang.png';
const _withScopeId = n => (_pushScopeId("data-v-115d4488"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "qrcodeContainer",
  class: "postCard"
}, null, -1));
const _hoisted_2 = {
  class: "tc",
  id: "tx"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des",
  style: {
    "color": "#C3C1C3"
  }
}, " 打开对方的企业微信名片 ", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "25px",
    "height": "25px",
    "margin-right": "5px",
    "border-radius": "3px"
  },
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "在线客服", -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "6F6D70"
  }
}, "取消", -1));
const _hoisted_8 = [_hoisted_7];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleBack && $options.handleBack(...args))
  }, _toDisplayString($data.icon), 1), _hoisted_1, $data.show ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "mc",
    id: "mc",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onCancel && $options.onCancel(...args))
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
    class: "ls row column-c row-c",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.handleWx && $options.handleWx(...args))
  }, _hoisted_6), _createElementVNode("div", {
    class: "qx",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.onCancel && $options.onCancel(...args))
  }, _hoisted_8)])]);
}